import { FC } from 'react';
import { observer } from "mobx-react-lite";
import "../../buttons/DefaultButtons.css"

export interface IButtonBaseProps {
    onClickFunc: () => void;
    textContent: string;
    optionalClasses?: string;
    dataTestId?: string;
}

const ButtonBase: FC<IButtonBaseProps> = ({ onClickFunc, textContent, optionalClasses,}) => {
    return (
        <button className={"text-button-base " + optionalClasses} onClick={() => onClickFunc()}>
            {textContent}
        </button>
    )
}

export default observer(ButtonBase);